// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-number input[data-v-3c7756e1] {\n  background-color: #F9F9FA;\n  padding: 15px;\n  font-size: 16px;\n  width: 100%;\n  border-radius: 8px;\n}\n.input-number--error input[data-v-3c7756e1] {\n  background-color: rgb(255, 147, 169);\n}\n.input-number__error[data-v-3c7756e1] {\n  color: rgb(255, 147, 169);\n  margin-top: 5px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
